export default "__VITE_ASSET__DP_5_9gx__"